export default "__VITE_ASSET__SF7R34N$__"